<template>
    <div class="conf-warp">
        <div v-if="showHard" class="conf-hard">
            <p style="width:80px;margin:0;color:#333;">初始难度</p>
            <span class="diff-reduce" @click="redHard">-</span>
            <div class="conf-slider"><mu-slider v-model="hard" @input="changeSlide" :max="max" :min="min" :step="1" class="demo-slider"/></div>
            <div class="rainbow-bar"></div>
            <span class="diff-plus" @click="addHard">+</span>
            <span style="position: absolute;right: -26px;top: -14px;width: 40px;height: 40px;"><input type="number" v-model="hard" class="conf-choose-hard" @keyup="inputHard"><span class="hard-line"></span></span>
            <span v-show="rightHard" style="position:absolute;color:red;font-size:12px;">请输入{{min}}~{{max}}范围内的数值</span>
        </div>
        <div class="conf-time">
            <p style="line-height:50px;width:80px;margin:0;color:#333;">训练时长</p>
            <div class="choose-time-wrap">
              <div class="conf-reduce" @click="redTime">-</div>
              <input type="number" v-model="time" class="conf-choose-day" @keyup="inputTime">
              <div class="conf-plus" @click="addTime">+</div>
            </div>
            <span style="position:absolute;top:12px;right:0;color:#333;">分钟</span>
            <span v-show="rightTime" style="color:red;font-size:12px;">请输入1~60范围内的数值</span>
        </div>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
export default {
  data(){
      return{
          hard:"",
          time:2,
          max:100,
          min:1,
          maxTime:60,//训练最大时长时60分钟
          rightHard:false,
          rightTime:false,
          caseId:"",
          showHard:true,
      }
  },
  props:{
    defaultTime:{
        type:Number,
        default:2,
    },
    showHardBar:{
        type:Boolean,
        default:true,
    },
    patientId:{
        type:String,
    },
  },
  computed:{
      ...mapState(["hardNum","gameData"])
  },
  mounted(){
      console.log(this.patientId);
      //不同游戏入口组件开始游戏的位置不一样，训练(iframe)组件与父组件平级，所以这个组件使用大量vuex的状态和方法
      if(this.patientId){
          this.caseId = this.patientId;
      }else{
          this.caseId = this.$route.params.id ? this.$route.params.id : this.$route.query.caseId;
      }
      this.getGameHisLev(this.caseId,this.gameData);
      //初始化2分钟的训练时间
      this.time = this.defaultTime;
      console.log(this.defaultTime);
      console.log(this.showHardBar);
      this.$store.commit("changeTime",this.time);
      this.getLevel();
  },
  methods:{
      //增加难度
      addHard(){
          this.hard > this.max - 1? this.hard = this.max:this.hard++;
          //增加难度时将难度传给vuex
          this.$store.commit("changeHard",this.hard);
          this.inputHard();
      },
      //减少难度
      redHard(){
          this.hard < this.min + 1? this.hard = this.min:this.hard--;
          //减少难度时将难度传给vuex
          this.$store.commit("changeHard",this.hard);
          this.inputHard();
      },
      changeSlide(){
          //监听滚动条时需要使用input事件，change事件只能监控滚动条滑动，不能监测点击
          //滑动滚动条时
          this.inputHard();
      },
      inputHard(){
          if(this.hard > this.max || this.hard < this.min || this.hard == ""){
              this.rightHard = true;
              //难度大于范围展示提示，且置灰开始按钮（开始按钮在父组件上，执行开始游戏的逻辑在父父组件上）
              this.$store.commit("changeStart",false);
          }else{
              this.rightHard = false;
              this.$store.commit("changeStart",true);
              //更改难度
              this.$store.commit("changeHard",this.hard);
          }
      },
      //减少训练时长
      redTime(){
          this.time < 2 ? this.time = 1 : this.time--;
          //减少时间的值传给vuex
          this.$store.commit("changeTime",this.time);
      },
      //增加训练时长
      addTime(){
          this.time > 59  ? this.time = 60 : this.time++;
          this.$store.commit("changeTime",this.time);
      },
      inputTime(){
          //check手动输入的值，并将值传给vuex
          if(this.time > 60){
              this.time = 60;
              this.$store.commit("changeTime",this.time);
          }else if(this.time < 1){
              this.time = 1;
              this.$store.commit("changeTime",this.time);
          }else{
              this.$store.commit("changeTime",this.time);
          }
      },
      //获取上次游戏等级
      getGameHisLev(caseId,game){
        var self = this;
        if(game.taskId){
          game["id"] = game.taskId;
        }
        this.$http({
            method: 'GET',
            url:'/api/Game/GameLevel',
            params: {
              'gameId': game.id,
              'patientId': caseId
            }
          })
          .then(
            function(res){
              this.hard = res.data.data.level;
              this.$store.commit("changeHard",this.hard);
            }
          )
      },
      getLevel(){
          //showHardBar为true则为2.0的认知游戏，否则为1.0游戏
        var conf = document.querySelector(".conf-time");
          if(this.showHardBar){
            //获取当前游戏最大和最小的等级
            GLOBAL.cognGames.forEach((item)=>{
              if(item.id == this.gameData.id){
                  this.min = item.minLevel;
                  this.max = item.maxLevel;
                  if(this.min !== 0 && this.max !== 0){
                      this.showHard = true;
                      conf.style.marginTop = 40 + "px";
                      conf.style.marginBottom = 0 + "px";
                  }else{
                      //没有难度等级时，隐藏等级设置，开始训练按钮高亮
                      this.showHard = false;
                      conf.style.marginTop = 20 + "px";
                      conf.style.marginBottom = 40 + "px";
                      this.$store.commit("changeStart",true);
                  }
              }
            })
          }else{
                this.showHard = false;
                conf.style.marginTop = 20 + "px";
                conf.style.marginBottom = 40 + "px";
                this.$store.commit("changeStart",true);
          }
      },
  }
}
</script>
<style>
.conf-warp{
    position: relative;
    width: 400px!important;
    margin-left:8px;
}
.conf-slider{
    position:absolute;
    top:0;
    right:72px;
}
.conf-warp .mu-slider{
    width: 200px!important;
    margin-bottom: 0!important;
}
.conf-time{
    position: relative;
    height:50px;
    margin-top: 40px;
}
.choose-time-wrap{
    position: absolute;
    top: 6px;
    right: 50px;
    width: 260px;
    height: 40px;
    padding: 0 20px 0 20px;
    border:1px solid #ddd;
    border-radius: 20px;
}
.conf-choose-day{
    text-align: center;
    width: 120px;
    height: 36px;
    display: block;
    margin: 0 auto;
    outline: none;
    border: 0px;
    font-size:16px;
}
.conf-choose-hard{
    position: absolute;
    top: 0px;
    width: 60px;
    height:50px;
    text-align: center;
    outline: none;
}
.conf-reduce{
    position: absolute;
    top: -2px;
    width: 28px;
    height:40px;
    line-height:40px;
    color: #2196f3 !important;
    font-size: 34px;
    cursor: pointer;
    left: 20px;
	color: rgba(0, 0, 0, 0.6);
}
.conf-plus{
    position: absolute;
    top: -2px;
    width: 28px;
    height:40px;
    line-height:40px;
    color: #2196f3 !important;
    font-size: 34px;
    cursor: pointer;
    right: 10px;
	color: rgba(0, 0, 0, 0.6);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
}

.conf-warp .mu-auto-complete{
    width:40px !important;
}
.conf-warp .mu-text-field{
    width:40px !important;
}
.conf-wrap .mu-text-field-input{
    text-align: center !important;
}
.diff-reduce{
    position: absolute;
    left: 90px;
    top: 2px;
    width: 20px;
    height: 20px;
    font-size:34px;
    line-height: 12px;
    text-align: center;
    border:1px solid #eee;
    color:#0A81E5;
    cursor:pointer;
}
.diff-plus{
    position: absolute;
    right: 34px;
    top: 2px;width: 20px;
    height: 20px;
    font-size:22px;
    line-height: 20px;
    text-align: center;
    border:1px solid #eee;
    color:#0A81E5;
    cursor:pointer;
}
.conf-hard .mu-slider-thumb{
    background-color: #fff !important;
    width:8px;
    height:20px;
    color: #fff !important;
    border:1px solid #eee;
    border-radius: 0;
    z-index:9999;
}
.hard-line{
    position: absolute;
    top: 38px;
    width: 60px;
    height: 2px;
    background-color: #eee;
}
.rainbow-bar{
    position: absolute;
    top:8px;
    left: 128px;
    width:200px;
    height:10px;
    border-radius: 4px;
    background: linear-gradient(left,#1BBE9F, #7ED321 ,#F5A623 ,#F57023 ,#D52820);
    background: -webkit-linear-gradient(left,#1BBE9F, #7ED321 ,#F5A623 ,#F57023 ,#D52820);
}
</style>





// WEBPACK FOOTER //
// selectLevel.vue?20be0c69